/*
 * @Author: 17388316638 lemon1234..
 * @Date: 2022-09-09 10:04:53
 * @LastEditors: 17388316638 lemon1234..
 * @LastEditTime: 2022-09-14 10:10:21
 * @FilePath: \qcsdjyBigdataUI\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentView: "Summary",
    showTabs: false,
  },
  getters: {
    GET_CURRENTVIEW: (state) => {
      state.currentView = sessionStorage.getItem("currentView");
      return state.currentView;
    },
  },
  mutations: {
    SET_CURRENTVIEW: (state, value) => {
      sessionStorage.setItem("currentView", value);
      state.currentView = value;
    },
    SET_SHOWTABS: (state, value) => {
      state.showTabs = value;
    },
  },
  actions: {},
  modules: {},
});
